import clsx from 'clsx';
import React, { PropsWithChildren, useMemo } from 'react';

export interface ListItem {
  _id: string;
  selected: string;
  onClick: (e: any) => void;
}

export function ListItem({ _id, selected, onClick, children }: PropsWithChildren<ListItem>) {
  const highlight = useMemo(() => selected === _id, [_id, selected]);
  return (
    <tr
      className={clsx(
        'border-gray-20 cursor-pointer transition-colors duration-150 bg-white',
        'hover:bg-blue-10',
        'focus:outline-none focus-visible:ring',
        highlight ? 'bg-blue-5 cursor-pointer font-semibold' : 'border-b'
      )}
      onClick={onClick}
      tabIndex={highlight ? 0 : -1}
      aria-selected={Boolean(highlight)}
      data-testid="list-item"
    >
      {children}
    </tr>
  );
}

export default ListItem;
